const tpl = (fields) => ({ page: 'skills', ...fields })

export const SKILL_TEMPLATES_PART02 = [
  tpl({
    id: 'demo-tpl-skl-call-notes',
    title: 'Call notes to CRM',
    category: 'Sales',
    apps: ['HubSpot'],
    description: 'Turns rough call notes into a clean HubSpot note, updated deal fields, and follow-up tasks.',
    steps: ['Structure the notes into pains, stakeholders, and next steps', 'Update the deal stage and close date if they changed', 'Create follow-up tasks with due dates'],
    skill: {
      instructions: `**Given notes from a call:**

1. Rewrite them under **Pains**, **Stakeholders**, **Objections**, and **Next steps**.
2. Find the matching HubSpot deal; propose stage, amount, and close-date changes and ask before saving.
3. Log the cleaned note on the deal.
4. Create a HubSpot task for each next step with an owner and a due date.`,
      examples: ['Log these call notes to the Northwind deal', 'Turn my notes from the Acme call into CRM updates'],
    },
  }),
  tpl({
    id: 'demo-tpl-skl-interviews',
    title: 'Customer interview synthesis',
    category: 'Research',
    apps: ['Notion'],
    description: 'Finds the patterns across a batch of interview notes and backs each one with quotes.',
    steps: ['Read every interview page in the folder', 'Cluster recurring needs and frustrations', 'Write findings with supporting quotes'],
    skill: {
      instructions: `**For the Notion interview pages given:**

1. Read every page and pull out needs, frustrations, and workarounds.
2. Group them into themes; count how many interviews mention each.
3. For each theme write one finding sentence and two direct quotes with the interview name.
4. Finish with surprises and open questions worth a follow-up.`,
      examples: ['Synthesise the September onboarding interviews', 'What patterns are in the churned-customer interviews?'],
    },
  }),
]
